import { c as _c } from "react/compiler-runtime";
import { FormInputUrl } from '@systemeio/ui';
import { useApplePayActions } from 'modules/profile/payment-gateways/integrations/stripe/hooks';
import { ApplePayActivateDomainErrors, ApplePayActivateDomainModalForm } from 'modules/profile/payment-gateways/integrations/stripe/types';
import { useState } from 'react';
import ButtonLikeLink from 'shared/components/button-like-link';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { ApplePayIcon } from '@systemeio/ui/icons';
const defaultValues: ApplePayActivateDomainModalForm = {
  hostName: '',
  file: null
};
const defaultErrors: ApplePayActivateDomainErrors = {
  hostName: []
};
export interface ApplePayActivateDomainModalProps {
  afterLeave: () => void;
}
const ApplePayActivateDomainModal = t0 => {
  const $ = _c(22);
  const {
    afterLeave
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      badRequestHandler: t2 => {
        const {
          errors: errors_0
        } = t2;
        if (errors_0.fields) {
          setErrors(prev => ({
            ...prev,
            ...errors_0.fields
          }));
        }
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    connectDomain
  } = useApplePayActions(t1);
  let t2;
  if ($[1] !== connectDomain) {
    t2 = async t3 => {
      const {
        hostName
      } = t3;
      await connectDomain({
        hostName
      });
    };
    $[1] = connectDomain;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleActivateDomain = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onClose = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ButtonLikeLink onClick={() => setIsOpen(true)}><ApplePayIcon height={20} /></ButtonLikeLink>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t("dashboard.settings.payment_gateways.activate_apple_pay_domain.description");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t("global.domain");
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== afterLeave) {
    t7 = () => {
      setErrors(defaultErrors);
      afterLeave();
    };
    $[9] = afterLeave;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== errors || $[12] !== t) {
    t8 = [{
      field: "hostName",
      onRender: (value, onChange) => <FormInputUrl addonBefore="https://" key="hostname" error={errors.hostName?.join("")} type="url" placeholder="www.yourdomain.com" label={t("global.domain")} value={value} onChange={onChange} />
    }];
    $[11] = errors;
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = ["hostName"];
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== handleActivateDomain || $[16] !== isOpen || $[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t10 = <>{t4}<CreateModal defaultValues={defaultValues} opened={isOpen} modalDescription={t5} caption={t6} afterLeave={t7} onClose={onClose} onCreate={handleActivateDomain} creatable={t8} requiredFields={t9} /></>;
    $[15] = handleActivateDomain;
    $[16] = isOpen;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
export default ApplePayActivateDomainModal;